<template>
    <div class="modal modal-info fade" :id="id" tabindex="-1" role="dialog" :aria-labelledby="id" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4>{{ title }}</h4>
                </div>
                <div class="modal-body">
                    <div class="modal-inner">

                        <div class="form" v-if="type === 'select'">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group form-group-1">
                                        <label for="" class="form-label">{{ title2 }}</label>
                                        <select name="" id="" class="custom-select " v-model="item">
                                            <option
                                            v-for="position in positions"
                                            :key="position.id"
                                            :value="position.id"
                                            v-if="position.name"
                                        >
                                                {{ position.name}} {{ position.last_name ?? ''}}
                                        </option>
                                            <option
                                                v-for="position in positions"
                                                :value="position.id"
                                                :key="position.id"
                                                v-if="position.title"
                                            >
                                                {{ position.title}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form" v-if="type === 'input'">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group form-group-1">
                                        <label for="" class="form-label">{{ title2 }}</label>
                                        <div class="form-group form-group-1">
                                            <input type="text" class="form-control" v-model="item">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <CommonSearch
                            v-if="type === 'applicant'"
                            @update-info="updateEmployeeId"
                            :type="'applicant'"
                        />
                        <div class="btns-wrap mt-2">
                            <button data-dismiss="modal" class="btn btn--outline-primary">
                                {{ rejectText }}
                            </button>
                            <button class="btn btn--secondary" @click="sendInputData">
                                {{ confirmText }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import CommonSearch from "./CommonSearch.vue";

export default {
    name:'AddNewItemModal',
    components: {CommonSearch},
    props: {
        confirmText: String,
        title: String,
        title2: String,
        rejectText: String,
        type: String,
        positions: Array,
        id: String ,
    },
    data() {
        return {
            item: null
        }
    },
    emits: ['confirm'],
    methods:{
        updateEmployeeId(result) {
            this.item = result
        },
        sendInputData() {
            $(`#${this.id}`).modal('hide');
            this.$emit('confirm', this.item);
            this.item = null
        },
    },


}

</script>

<style scoped>

</style>
